export type StepState = "todo" | "in-progress" | "complete" | "error";

export const WorkflowStage = {
  UPLOADING: "uploading",
  CONVERTING: "converting",
  VALIDATING: "validating",
  PROCESSING: "processing",
  GETTING_RESULTS: "getting_results",
  DONE: "done",
} as const;
export type WorkflowStage = (typeof WorkflowStage)[keyof typeof WorkflowStage];

export interface WorkflowStep {
  label: string;
  secondaryLabel?: string;
  state: StepState;
  id: string;
}
